import HelloWorld from './HelloWorld'
import './App.css';

function App() {
  return (
    <div className="App">
    <HelloWorld></HelloWorld>
    </div>
  );
}

export default App;
